<div class="actions-dialog" [ngStyle]="{
    height: (subMenuSelected !== subMenuTypesEnum.PROFILE_DATA ||
    (subMenuSelected === subMenuTypesEnum.PROFILE_DATA && subMenuChanged)) ? '100%' : 'auto'
  }" [ngClass]="{'actions-dialog-discard-changes': subMenuChanged}">
    <div class="actions-dialog-container">
        <div>
            @if (!subMenuChanged) {
            <div class="actions-dialog-container-header">
                <app-actions-header #actionsHeader [isAdmin]="isAdmin" [isActive]="isActive" [user]="data.user"
                    [mode]="mode" [subMenuSelected]="subMenuSelected" [context]="context"
                    (closeEmitter)="closeDialog()" (subMenuSelectedEmitter)="changeSubMenu($event)"
                    (currentCheckEmitter)="changeActiveState($event)"></app-actions-header>
            </div>
            <div class="actions-dialog-container-body">
                @switch (subMenuSelected) {
                @case (subMenuTypesEnum.PROFILE_DATA) {
                <app-profile-data-submenu [user]="data.user" [context]="context"></app-profile-data-submenu>
                }
                @case (subMenuTypesEnum.CONTACT_INFORMATION) {
                <app-contact-information-submenu [contactDetails]="contactDetails"></app-contact-information-submenu>
                }
                @case (subMenuTypesEnum.FISCAL_DATA) {
                <app-fiscal-data-submenu [fiscalData]="fiscalData"></app-fiscal-data-submenu>
                }
                @case (subMenuTypesEnum.ROLES_AND_PERMISSIONS) {
                <app-roles-permissions-submenu [userRoles]="roles"
                    [userPermissionsWithoutRol]="permissionsWithoutRol"></app-roles-permissions-submenu>
                }
                }
            </div>
            } @else {
            <div class="actions-dialog-container-reset">
                <div class="d-flex justify-between border-separator">
                    <p class="actions-dialog-container-reset-title">{{
                        'configuration-page.action-dialog.unsaved-changes-title' |
                        translate }}</p>
                        <div>
                            <fa-icon class="font-16 icon" [icon]="['fal', 'xmark']"
                            (click)="closeDialog()"></fa-icon>
                        </div>
                </div>

                <p class="actions-dialog-container-reset-text m-t-15">{{
                    'configuration-page.action-dialog.unsaved-changes-label' |
                    translate }}</p>
            </div>
            }

        </div>

        <div class="actions-dialog-container-footer">
            @if (!subMenuChanged) {
            <button mat-raised-button color="secondary" type="submit" class="secondary" (click)="closeDialog()">{{
                'configuration-page.action-dialog.btn-cancel' | translate }}</button>
            <button mat-raised-button color="primary" type="submit" (click)="save(false)"
                [disabled]="(subMenuFormGroup && subMenuFormGroup.invalid) || !hasChanges">{{
                'configuration-page.action-dialog.btn-save' | translate }}</button>
            } @else {
            <button mat-raised-button color="secondary" type="submit" class="secondary" (click)="discardChanges()">{{
                'configuration-page.action-dialog.btn-discard-changes' | translate }}</button>
            <button mat-raised-button color="primary" type="submit" (click)="save(true)"
                [disabled]="(subMenuFormGroup && subMenuFormGroup.invalid) || !hasChanges">{{
                'configuration-page.action-dialog.btn-save' | translate }}</button>
            }

        </div>
    </div>

</div>
